import { useHistory, useLocationHref } from '@atlassian/mpac-ui';
import { RecentSearch } from '../../../SearchUtils';
import { redirectToNewQuery } from '../../../SearchUtils/search-navigation-utils/SearchNavigationUtils';
// TODO handle duplicate recent search for overlay and embedded
const recentSearch = new RecentSearch(5, 'mpac-search-recent-searches');
export const useSearchDropdown = _ref => {
  let {
    inputRef,
    autocomplete
  } = _ref;
  const locationHref = useLocationHref();
  const history = useHistory();
  const handleAppend = hit => {
    var _inputRef$current;
    autocomplete.setQuery(hit.query);
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };
  const handleEnterKeyPress = query => {
    redirectToNewQuery({
      query,
      locationHref,
      history
    });
  };
  const clearRecentSearches = () => {
    recentSearch.clearAll();
    autocomplete.refresh();
  };
  const clearSearchInput = () => {
    if (inputRef.current && inputRef.current.value) {
      autocomplete.setQuery('');
      inputRef.current.focus();
    }
  };
  return {
    handleAppend,
    handleEnterKeyPress,
    clearRecentSearches,
    clearSearchInput
  };
};